














































import Vue from "vue";
import { isNil } from "ramda";
import Header from "@/components/Header.vue";
import { RequestService } from "@/services";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user'],
  components: {
    Header
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      modalTitle: '',
    };
  },
  methods: {
    database: function() {
      const vm = this as any;
      vm.$router.push({ name: 'database', params: {user: vm.loggedUser}});
    },
    censimentoProdotti: function() {
      const vm = this as any;
      vm.$router.push({ name: 'censimento-prodotti', params: {user: vm.loggedUser}});
    },
    getUser: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.loggedUser = result;
        });
    },
    openModal(title: string) {
      const vm = this as any;
      vm.modalTitle = title;
      vm.$bvModal.show("modal-cambio-password");
    },
    closeModal() {
      const vm = this as any;
      vm.$bvModal.hide("modal-cambio-password");
      vm.$router.push({ name: 'cambio-password', params: {user: vm.loggedUser}});
    },
    onClickModal() {
      const vm = this as any;
      vm.closeModal();
    },
  },
  created() {
    const vm = this as any;
    if (vm.$props.user == undefined) {
      vm.getUser();
    }
  },
  mounted() {
    const vm = this as any;
    if (vm.loggedUser && (vm.loggedUser.firstAccess || vm.loggedUser.passwordExpired)) {
      vm.openModal(vm.loggedUser.firstAccess ? 'Password di primo accesso' : 'Password scaduta');
    }
  }
});
